import { Sticker } from '../constants/Sticker';

const sticker = (stickerId) => `${Sticker.baseurl}/${stickerId}.png`;

export default sticker;
